/**
 * User Page JavaScript
 * Handles user page related functionality including default voice management and date editing
 */

import $ from 'jquery';
import { setupUserProfileDefaultVoice } from './defaultVoice.js';

$(document).ready(function() {
    
    // Initialize default voice functionality for user profile modal
    function initUserProfileDefaultVoice() {
        // Get ensemble slug and edited user ID from change voice icon data attribute
        const $changeVoiceIcon = $('i[data-bs-target="#changeVoiceModal"]');
        const ensembleSlug = $changeVoiceIcon.data('ensemble-slug');
        const editedUserId = $changeVoiceIcon.data('edited-user-id');
        
        if (ensembleSlug && editedUserId && $('#voice-select').length) {
            setupUserProfileDefaultVoice(ensembleSlug, editedUserId);
        }
    }
    
    initUserProfileDefaultVoice();

    // Open the modal when the icon is clicked
    $('.joined_edit').on('click', function() {
        $('#editJoinDateModal').modal('show');
    });

    // Handle the "Save" button click inside the modal
    $('#saveDateBtn').on('click', function() {
        
        
        function getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let cookie of cookies) {
                    cookie = cookie.trim();
                    if (cookie.startsWith(name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
        const csrftoken = getCookie('csrftoken');
        
        
        let selectedDate = $('.datepicker').val();

        if (selectedDate) { 
            let memberID = $('.joined_edit').data('ensemblemember-id');
            let ensembleSlug = $('.joined_edit').data('ensemble-slug');
            let apiUrl = $('.joined_edit').data('update-url');
            
            $.ajax({
                url: apiUrl,
                headers: { "X-CSRFToken": csrftoken },
                type: 'POST',
                data: {
                    'date': selectedDate,
                    'member_id': memberID,
                    'ensemble_slug': ensembleSlug,
                },
                success: function(response) {
                    console.log('Success:', response);
                    $('#editJoinDateModal').modal('hide');
                    $('.user-joined-at').text(response.joined_at);
                },
                error: function(xhr, status, error) {
                    console.error('Błąd status:', xhr.status); 
                    
                    let errorMessage = "Wystąpił nieznany błąd serwera.";
                    
                    try {
                        const responseData = JSON.parse(xhr.responseText);
                    
                        if (responseData.message) {
                            errorMessage = responseData.message;
                        }
                        
                    } catch (e) {
                        console.error("Błąd parsowania odpowiedzi serwera:", e);
                        if (error) {
                             errorMessage = `Błąd sieci lub serwera: ${error}`;
                        }
                    }
                    console.error(errorMessage);
                    alert(errorMessage);
                }
            });
        } else {
            alert('Proszę wybrać datę.');
        }
    });
});
